import { render, staticRenderFns } from "./ListDeliveries.vue?vue&type=template&id=39ecda6f&lang=pug"
import script from "./ListDeliveries.vue?vue&type=script&lang=js"
export * from "./ListDeliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports